import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Slider from "react-slick";
import Container from "react-bootstrap/Container";

import banner5 from "../assets/images/landing/zero-m-landing.png";

import bannermobile5 from "../assets/images/ancillary-solutions-category6-mobile.png";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Breadcrumb from "react-bootstrap/Breadcrumb";

import ancillarysolutions from "../assets/images/ancillary-solutions.png";
import repairSolution from "../assets/images/Repair-Solutions.png";
import tileStoneFixing from "../assets/images/Tile-Stone-Fixing-solutions.png";
import surfaceSolution from "../assets/images/surface-preperation-solutions.png";
import waterproofingSolution from "../assets/images/waterproofing-solutions.png";

import { Helmet } from "react-helmet";
import Carousel from "react-bootstrap/Carousel";
import brochurePdf from "../assets/pdf/MBM-Corporate.pdf";
import { useTranslation } from "react-i18next";

import enhancedEarningImage from "../assets/images/ico/enhanced-earning-potential.png";
import businessSupportImage from "../assets/images/ico/established-business-support.png";
import brandAssociationImage from "../assets/images/ico/strong-brand-association.png";
import influencerNetworkImage from "../assets/images/ico/strong-influencer-network.png";
import digitalEcosystemImage from "../assets/images/ico/transparent-digital-&-connected-ecosystem.png";
import PartnershipForm from "../common/PartnershipForm";

const settings = {
  //centerMode: true,
  //autoplay:true,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: false,
  arrow: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
};

const ZeroMPartnership = () => {
  const { t } = useTranslation();
  const [one, setOne] = useState(false);
  const closeOne = () => setOne(false);

  const [two, setTwo] = useState(false);
  const closeTwo = () => setTwo(false);

  const [three, setThree] = useState(false);
  const closeThree = () => setThree(false);

  const [four, setFour] = useState(false);
  const closeFour = () => setFour(false);

  const [five, setFive] = useState(false);
  const closeFive = () => setFive(false);

  const showComponent = (varname) => {
    switch (varname) {
      case "one":
        setOne(true);
        break;
      case "two":
        setTwo(true);
        break;
      case "three":
        setThree(true);
        break;
      case "four":
        setFour(true);
        break;
      case "five":
        setFive(true);
        break;

      default:
        return;
    }
  };

  return (
    <div className="aboutus-pge inner_page">
      <Helmet>
        <title>{t("SEO.ourMBM.title")}</title>
        <meta name="keywords" description="" />
        <meta name="description" content={t("SEO.ourMBM.desc")} />
        <link
          rel="canonical"
          href={window.location.origin + window.location.pathname}
        />
        <link
          rel="alternate"
          hreflang="en"
          href={t("SEO.ourMBM.alternateLinks.en")}
        />
        <link
          rel="alternate"
          hreflang="gu"
          href={t("SEO.ourMBM.alternateLinks.guj")}
        />
        <link
          rel="alternate"
          hreflang="hi"
          href={t("SEO.ourMBM.alternateLinks.hi")}
        />
        <link
          rel="alternate"
          hreflang="x-default"
          href={t("SEO.ourMBM.canLink")}
        />
        <style>{`.carousel-control-prev,.carousel-control-next,.carousel-indicators { display: none; }`}</style>
      </Helmet>
      <div className="banner text-center position-relative">
        <div className="mbmProduct">
          <Carousel>
            <Carousel.Item>
              <a href="#form">
                <img className="desktopbannerinner " src={banner5} alt="" />
                <img className="mobilebannerinner" src={banner5} alt="" />
              </a>
            </Carousel.Item>
          </Carousel>
        </div>

        <div className="breadouter">
          <div className="container">
            <Breadcrumb className="mb-0 py-2">
              <Breadcrumb.Item href="#">{t("breadcrumb.home")}</Breadcrumb.Item>
              <Breadcrumb.Item
                active
                href="https://getbootstrap.com/docs/4.0/components/breadcrumb/"
              >
                Become a Dealer
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <div className="midpart">
        <Container>
          <h1 className="grad-heading">Become a Dealer</h1>

          <p>
            <strong>
              India’s trusted building materials company invites you to become a
              dealer or distributor for our premium Modern Building Materials
              range – ZERO M.
            </strong>
          </p>
          <p>
            Nuvoco Zero M is redefining the construction ecosystem with modern,
            innovative, and sustainable building materials.
          </p>
          <p>
            The portfolio includes Construction Chemicals, Multipurpose Bonding
            and Waterproofing Agents, Wall Putty, Tile & Stone Adhesives, Tile
            Grouts, Ready-Mix Dry Plaster, Block Joining Mortar, Dry Bag
            Concrete and Cover Blocks. Whether it’s ensuring the longevity of
            structures through effective waterproofing solutions, enhancing
            aesthetics with superior tile and stone fixing products, or
            providing reliable repair and surface preparation solutions, ZERO M
            is committed to delivering excellence in every aspect of building
            materials
          </p>

          <div className="our_brand_inner">
            <div className="card_round pt-5">
              <Container>
                <h2 className="grad-heading pd-5 mb-5">
                  Why Partner with Nuvoco ZERO M
                </h2>
                <Row className="pb-4 justify-content-center align-items-center">
                  {[
                    {
                      title: "Enhanced Earning Potential",
                      description:
                        "Join a fast-growing, profitable business model designed to deliver higher returns. With structured support, innovative products, and a trusted brand ecosystem, your investment grows stronger with every milestone.",
                      img: enhancedEarningImage,
                    },
                    {
                      title: "Strong Brand Association",
                      description:
                        "Partner with <strong>Nuvoco</strong> – a name built on <strong>trust, innovation, and excellence</strong>. ZERO M offers you a credible and future-ready partnership in the evolving world of modern building materials.",
                      img: brandAssociationImage,
                    },
                    {
                      title: "Established Business Support",
                      description:
                        "Leverage Nuvoco’s extensive <br/><strong>Cement and RMX network</strong> to accelerate your market entry and build a strong business with seamless operational and marketing support.",
                      img: businessSupportImage,
                    },
                    {
                      title: "Transparent, Digital & Connected Ecosystem",
                      description:
                        "Experience a <strong>digitally empowered business model</strong> that ensures transparency, efficiency, and real-time growth tracking — simplifying everything from onboarding to <br/>day-to-day operations.",
                      img: digitalEcosystemImage,
                    },
                    {
                      title: "Influencer Network & Engagement Programs",
                      description:
                        "Benefit from <strong>robust influencer and engagement initiatives</strong> that enhance visibility, expand your customer base, and sustain continuous business momentum.",
                      img: influencerNetworkImage,
                    },
                  ].map((card, index) => (
                    <Col
                      md={4}
                      lg={4}
                      className="mb-5 wow fadeInUp"
                      key={index}
                    >
                      <Card onClick={() => showComponent(`card${index + 1}`)}>
                        <Card.Body style={{ padding: 0, minHeight: 360 }}>
                          <img
                            src={card.img}
                            alt={card.title}
                            style={{ maxWidth: "100px", margin: "0 auto" }}
                          />
                          <h4 className="mb-3 gradient-title">
                            {card.title} <br />
                          </h4>{" "}
                          <div
                            dangerouslySetInnerHTML={{
                              __html: `${card.description}`,
                            }}
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Container>
            </div>
          </div>

          <PartnershipForm />
        </Container>
      </div>
      <Modal
        size="lg"
        centered="true"
        show={one}
        onHide={closeOne}
        className="bob_modal bob_modal1 product_modal our_brand_inner card_round"
      >
        <Modal.Body>
          <Modal.Header closeButton></Modal.Header>
          <Row>
            <Col md={12} className="d-flex align-items-center">
              <h2 className="grad-heading pd-5 m-0">
                {t("our_business.mbm.Waterproofing_Solutions")}{" "}
                {t("our_business.mbm.solution")}
              </h2>
            </Col>
            <Col md={12}>
              <div className="d-flex align-items-center mt-3">
                <img
                  src={waterproofingSolution}
                  alt=""
                  style={{ maxWidth: "300px" }}
                />
                <article className="p-4">
                  {t("our_business.mbm.water_description")}
                </article>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        centered="true"
        show={two}
        onHide={closeTwo}
        className="bob_modal bob_modal1 product_modal our_brand_inner card_round"
      >
        <Modal.Body>
          <Modal.Header closeButton></Modal.Header>
          <Row>
            <Col md={12} className="d-flex align-items-center">
              <h2 className="grad-heading pd-5 m-0">
                {t("our_business.mbm.Surface_Preparation")}{" "}
                {t("our_business.mbm.solution")}
              </h2>
            </Col>
            <Col md={12}>
              <div className="d-flex align-items-center mt-3">
                <img
                  src={surfaceSolution}
                  alt=""
                  style={{ maxWidth: "300px" }}
                />
                <article className="p-4">
                  {t("our_business.mbm.Surface_description")}
                </article>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        centered="true"
        show={three}
        onHide={closeThree}
        className="bob_modal bob_modal1 product_modal our_brand_inner card_round"
      >
        <Modal.Body>
          <Modal.Header closeButton></Modal.Header>
          <Row>
            <Col md={12} className="d-flex align-items-center">
              <h2 className="grad-heading pd-5 m-0">
                {t("our_business.mbm.tile_stone")}{" "}
                {t("our_business.mbm.solution")}
              </h2>
            </Col>
            <Col md={12}>
              <div className="d-flex align-items-center mt-3">
                <img
                  src={tileStoneFixing}
                  alt=""
                  style={{ maxWidth: "300px" }}
                />
                <article className="p-4">
                  {t("our_business.mbm.tile_stone_description")}{" "}
                </article>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        centered="true"
        show={four}
        onHide={closeFour}
        className="bob_modal bob_modal1 product_modal our_brand_inner card_round"
      >
        <Modal.Body>
          <Modal.Header closeButton></Modal.Header>
          <Row>
            <Col md={12} className="d-flex align-items-center">
              <h2 className="grad-heading pd-5 m-0">
                {t("our_business.mbm.Repair_Solutions")}{" "}
                {t("our_business.mbm.solution")}
              </h2>
            </Col>
            <Col md={12}>
              <div className="d-flex align-items-center mt-3">
                <img
                  src={repairSolution}
                  alt=""
                  style={{ maxWidth: "300px" }}
                />
                <article className="p-4">
                  {t("our_business.mbm.repair_description")}
                </article>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        centered="true"
        show={five}
        onHide={closeFive}
        className="bob_modal bob_modal1 product_modal our_brand_inner card_round"
      >
        <Modal.Body>
          <Modal.Header closeButton></Modal.Header>
          <Row>
            <Col md={12} className="d-flex align-items-center">
              <h2 className="grad-heading pd-5 m-0">
                {t("our_business.mbm.Ancillary_Solutions")}{" "}
                {t("our_business.mbm.solution")}
              </h2>
            </Col>
            <Col md={12}>
              <div className="d-flex align-items-center mt-3">
                <img
                  src={ancillarysolutions}
                  alt=""
                  style={{ maxWidth: "300px" }}
                />
                <article className="p-4">
                  {t("our_business.mbm.Ancillary_description")}
                </article>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ZeroMPartnership;
